export default __webpack_public_path__ + "static/media/tees.68402385.png";